import FormattedMessage from 'I18n/components/FormattedMessage';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useMutation } from 'data-fetching-client';
import { addAlert } from '../../../utils/alerts';
import { useTracker } from '../../../utils/usageTracker';
import { DELETE_SUBSCRIPTION } from './deleteSubscriptionApi';
import { jsx as _jsx } from "react/jsx-runtime";
export function useDeleteSubscription({
  objectId,
  onClose
}) {
  const {
    trackDeletion
  } = useTracker();
  const sendSubscriptionDeletedMessage = useSendCrmMessageTopic(TOPIC_NAMES.OBJECT_DELETED);
  return useMutation(DELETE_SUBSCRIPTION, {
    variables: {
      objectId
    },
    fetchPolicy: 'network-only',
    onError: () => {
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.DeleteSubscriptionModal.alert.error"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.DeleteSubscriptionModal.alert.errorMessage"
        }),
        type: 'danger'
      });
      onClose();
    },
    onCompleted: () => {
      trackDeletion({
        subType: 'delete',
        type: 'merchant-usage'
      });
      sendSubscriptionDeletedMessage({
        objectId: String(objectId),
        objectTypeId: SUBSCRIPTION_TYPE_ID
      });
      addAlert({
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.DeleteSubscriptionModal.alert.success"
        }),
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.DeleteSubscriptionModal.alert.successMessage"
        }),
        type: 'success'
      });
      onClose();
    }
  });
}